import { DataBean } from "../DataBean";

export class QualityGarment extends DataBean {

  public async getQualityGarmentCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityGarmentCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteQualityGarment(idqualitygarment: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityGarment_Number", [idqualitygarment]);
  }

  public async updateQualityGarment(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityGarment_updateQualityGarment_com.orange.finance.processcontract.bean.QualityGarment",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityGarment",
        },
      ]
    );
  }
}
